
import { useAppStore } from '@/store/appStore'

/**
 * Shared EarningsBadge — shows "📅Xd" next to a ticker if earnings are within 60 days.
 * Color: red ≤7d, orange ≤14d, gray otherwise.
 * Used on Watchlist, Trade pages, and Positions section.
 */
export function EarningsBadge({ ticker }: { ticker: string }) {
  const earningsCalendar = useAppStore(s => s.earningsCalendar)
  const earningsData = earningsCalendar[ticker]
  if (!earningsData || !earningsData.date) return null

  const earningsDate = new Date(earningsData.date + 'T00:00:00')
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const diffMs = earningsDate.getTime() - today.getTime()
  const daysUntil = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

  // Only show if within 60 days
  if (daysUntil < 0 || daysUntil > 60) return null

  const color = daysUntil <= 7 ? 'text-red-600' : daysUntil <= 14 ? 'text-orange-500' : 'text-gray-500'

  return (
    <span
      className={`ml-1.5 text-[10px] font-medium ${color}`}
      title={`Earnings: ${earningsData.date}${earningsData.hour ? ` (${earningsData.hour === 'bmo' ? 'Before Open' : earningsData.hour === 'amc' ? 'After Close' : earningsData.hour})` : ''}`}
    >
      📅{daysUntil}d
    </span>
  )
}
